import { HELP_ARTICLES } from './helpUrls';

import type { AccordionItemConfig } from '@/components/Accordion';
import { SupportedLocation } from '@/modules/location/constants';

const CLOUDFRONT_HOST = process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST;

export type { AccordionItemConfig };

export type WhyChooseBulletConfig = {
  translationKey: string;
  linkUrl?: string;
  locales?: SupportedLocation[];
};

export type WhyChooseSectionConfig = {
  subheadingKey: string;
  bullets: WhyChooseBulletConfig[];
};

export const whyChooseDepopShippingUrl = `${CLOUDFRONT_HOST}/web/assets/shippingPage/why_choose_depop_shipping.webp`;

export const youtubeVideoId = 'UDTyWn6h0YI';
export const ausYoutubeVideoId = 'mhCFeQgpAuk';

export const accordionData: AccordionItemConfig[] = [
  {
    titleKey: 'ShippingPage.FAQ.HowToShipAUS.Title',
    contentKey: 'ShippingPage.FAQ.HowToShipAUS.Content',
    linkUrl: HELP_ARTICLES.HOW_TO_SHIP.AUS,
  },
  {
    titleKey: 'ShippingPage.FAQ.HowToShipUS.Title',
    contentKey: 'ShippingPage.FAQ.HowToShipUS.Content',
    linkUrl: HELP_ARTICLES.HOW_TO_SHIP.US,
  },
  {
    titleKey: 'ShippingPage.FAQ.TariffsUS.Title',
    contentKey: 'ShippingPage.FAQ.TariffsUS.Content',
    linkUrl: HELP_ARTICLES.TARIFFS,
  },
  {
    titleKey: 'ShippingPage.FAQ.HowToShipUK.Title',
    contentKey: 'ShippingPage.FAQ.HowToShipUK.Content',
    linkUrl: HELP_ARTICLES.HOW_TO_SHIP.UK,
  },
  {
    titleKey: 'ShippingPage.FAQ.ShippingBundles.Title',
    contentKey: 'ShippingPage.FAQ.ShippingBundles.Content',
    linkUrl: HELP_ARTICLES.HOW_TO_SHIP.BUNDLES,
  },
  {
    titleKey: 'ShippingPage.FAQ.EcoFriendlyPackaging.Title',
    contentKey: 'ShippingPage.FAQ.EcoFriendlyPackaging.Content',
    linkUrl: HELP_ARTICLES.ECO_FRIENDLY_PACKAGING,
  },
];

export const whyChooseSectionData: WhyChooseSectionConfig[] = [
  {
    subheadingKey: 'ShippingPage.WhyChooseDepopShipping.Subheading1',
    bullets: [
      { translationKey: 'ShippingPage.WhyChooseDepopShipping.BulletPoint1' },
      {
        translationKey: 'ShippingPage.WhyChooseDepopShipping.USExclusive',
        locales: [SupportedLocation.US],
      },
      { translationKey: 'ShippingPage.WhyChooseDepopShipping.BulletPoint2' },
    ],
  },
  {
    subheadingKey: 'ShippingPage.WhyChooseDepopShipping.Subheading2',
    bullets: [
      { translationKey: 'ShippingPage.WhyChooseDepopShipping.BulletPoint3' },
      { translationKey: 'ShippingPage.WhyChooseDepopShipping.BulletPoint4' },
      {
        translationKey: 'ShippingPage.WhyChooseDepopShipping.BulletPoint5',
        linkUrl: HELP_ARTICLES.DEPOP_PROTECTION_FOR_SELLERS,
      },
    ],
  },
];
